import { usePolicyDetail } from "data/ss-data-hooks";

export const usePropertyUpdateTrampoline = () => {
  const { data, isLoading } = usePolicyDetail();

  return {
    loading: isLoading,
    prevTrampoline: data?.userPropertyProfileData.trampoline,
  };
};
